export default "__VITE_ASSET__e23f28df__"